import { useState } from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";
import {
  FiHome,
  FiFileText,
  FiPlusCircle,
  FiLogOut,
  FiMenu,
  FiX,
  FiUsers,
  FiBell,
} from "react-icons/fi";
import StandingsDropdown from "../StandingsDropdown";


export default function DashboardLayout({ setAdmin }) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const logout = async () => {
    await signOut(auth);
    setAdmin(false);
    navigate("/");
  };

  return (
    <div className="flex min-h-screen bg-neutral-950 text-white">

      {/* MOBILE OVERLAY */}
      {open && (
        <div
          className="fixed inset-0 bg-black/60 z-40 lg:hidden"
          onClick={() => setOpen(false)}
        />
      )}

      {/* SIDEBAR */}
      <aside
        className={`fixed lg:static z-50 inset-y-0 left-0 w-64
        bg-neutral-900 border-r border-neutral-800
        transform transition-transform duration-300
        ${open ? "translate-x-0" : "-translate-x-full"}
        lg:translate-x-0 flex flex-col`}
      >
        {/* HEADER */}
        <div className="flex items-center justify-between p-5 border-b border-neutral-800">
          <div>
            <h2 className="text-lg font-semibold">Echoes of Engine</h2>
            <p className="text-xs text-neutral-400 tracking-widest">
              ADMIN PANEL
            </p>
          </div>

          <button
            onClick={() => setOpen(false)}
            className="lg:hidden text-neutral-400 hover:text-white"
          >
            <FiX size={20} />
          </button>
        </div>

        {/* NAV */}
        <nav className="flex-1 p-4 space-y-1">
          <NavItem to="/dashboard" icon={<FiHome />} label="Dashboard" onClick={() => setOpen(false)} />
          <NavItem to="/races" icon={<FiFileText />} label="Races" onClick={() => setOpen(false)} />
          <NavItem to="/create" icon={<FiPlusCircle />} label="Drivers" onClick={() => setOpen(false)} />
          <NavItem to="/categories" icon={<FiFileText />} label="Intelligence" onClick={() => setOpen(false)} />
          <NavItem to="/calendar" icon={<FiFileText />} label="Settings" onClick={() => setOpen(false)} />
          <NavItem to="/users" icon={<FiUsers />} label="Users" />
          <NavItem to="notifications" icon={<FiBell />} label="Notifications" />
          <StandingsDropdown />

        </nav>

        {/* LOGOUT */}
        <button
          onClick={logout}
          className="flex items-center gap-3 px-5 py-4 border-t border-neutral-800
                     text-neutral-400 hover:text-red-400"
        >
          <FiLogOut />
          Logout
        </button>
      </aside>

      {/* MAIN */}
      <div className="flex-1 flex flex-col">
        <header className="lg:hidden flex items-center gap-4 p-4 border-b border-neutral-800">
          <button
            onClick={() => setOpen(true)}
            className="text-neutral-300 hover:text-white"
          >
            <FiMenu size={22} />
          </button>
          <h1 className="text-sm font-semibold">Admin Panel</h1>
        </header>

        <main className="flex-1 p-4 sm:p-6 lg:p-8 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

/* NAV ITEM */
function NavItem({ to, icon, label, onClick }) {
  return (
    <NavLink
      to={to}
      onClick={onClick}
      className={({ isActive }) =>
        `flex items-center gap-3 px-4 py-3 rounded-lg text-sm transition
        ${isActive
          ? "bg-red-500/10 text-red-400"
          : "text-neutral-400 hover:bg-neutral-800 hover:text-white"
        }`
      }
    >
      {icon}
      {label}
    </NavLink>
  );
}
